import { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

/**
 * Sets table search params based on the current active filters
 * @param tableFilters table active filters
 * @param autoCorrect auto correct page when results less than current page
 * @param requiredFiltersToUpdate Array of keys that MUST be present
 *                                (with a non‑empty value) before the URL is updated.
 */
export const useInitTableSearchParams = (
  tableFilters,
  autoCorrect,
  requiredFiltersToUpdate,
) => {
  const history = useHistory();
  const location = useLocation();
  const [autoCorrectPage, setAutoCorrectPage] = autoCorrect;

  useEffect(() => {
    const allRequiredPresent = requiredFiltersToUpdate.every((key) => {
      const val = tableFilters[key];
      return val !== undefined && val !== null && val !== '';
    });

    if (!allRequiredPresent) return;

    /* ---------- 2. Build a *canonical* query string ---------- */
    const searchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(tableFilters)) {
      if (key !== '' && value !== null && value !== undefined && value !== '') {
        searchParams.append(key, value);
      }
    }

    // To avoid false mismatches caused by key order, sort alphabetically:
    const canonical = [...searchParams.entries()]
      .sort(([a], [b]) => a.localeCompare(b))
      .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
      .join('&');

    /* ---------- 3. Compare with current URL and update if different ---------- */
    const current = location.search.startsWith('?')
      ? location.search.slice(1)
      : location.search;

    if (canonical === current) return;

    if (autoCorrectPage || current == '') {
      history.replace({
        search: canonical,
      });
      setAutoCorrectPage(false);
    } else
      history.push({
        search: canonical,
      });
  }, [history, tableFilters, autoCorrectPage]);
};
